import {useFormContext} from "react-hook-form";
import {ComponentProps} from "react";
import {LabelField, LabelFieldProps} from "@/components/form/LabelField";
import {Textarea} from "@/components/ui/textarea";
import {useFormField} from "@/components/ui/form";

type TextareaFieldProps = ComponentProps<typeof Textarea> & LabelFieldProps

export function TextareaField({label, name, maxLength, containerClassName, hideError, ...props}: TextareaFieldProps) {
    const form = useFormContext()
    return (
        <LabelField label={label} name={name} containerClassName={containerClassName} hideError={hideError}>
            <div>
                <LabelField label={false} name={name} hideError>
                    <Textarea
                        id={name}
                        {...form.register(name)}
                        maxLength={maxLength}
                        {...props}
                    />
                </LabelField>
                {maxLength && <Counter maxLength={maxLength}/>}
            </div>
        </LabelField>
    )
}

function Counter({maxLength}: { maxLength: number }) {
    const form = useFormContext()
    const field = useFormField()
    const value = form.watch(field.name)
    if (!value || value.length < maxLength * .2) {
        return null
    }
    return <div className={'w-full relative bg-amber-500'}>
        <span className="bg-white px-2 absolute -top-2  right-3 text-xs text-muted-foreground text-right">{maxLength - value.length} characters left</span>
    </div>
}

TextareaField.displayName = "TextareaField";

